import LoadingWrapper from "../components/Layout/LoadingWrapper";
import Login from "../components/_Login";

const LoginPage = (props: any) => (
    <LoadingWrapper>
        <Login />
    </LoadingWrapper>
)
export default LoginPage